import { useCallback, useEffect } from 'react';
import Button from 'src/components/design-system/Button';
import useCompany from 'src/hooks/useCompany';
import useGuideMe from 'src/hooks/useGuideMe';
import useViewDepartment from 'src/hooks/useViewDepartments';
import { SelectedDepartment } from './ViewDepartmentContext';
import useManageDepartmentsGuideMeSteps from './useManageDepartmentsGuideMeSteps';

const ManageDepartmentNavBar = () => {
  const {
    isManageDepartmentDirty,
    t,
    setSelectedDepartment,

    handleSaveClick,
    isSaveDepartmentLoading,
    confirmBeforeProceeding,
  } = useViewDepartment();

  const { company } = useCompany();

  const { guideMe, openGuideMe } = useGuideMe({
    steps: useManageDepartmentsGuideMeSteps(),
    guideId: 'manage-departments',
  });

  useEffect(() => {
    if (company?.companyId) {
      openGuideMe();
    }
  }, [company?.companyId, openGuideMe]);

  const handleCancelClick = useCallback(() => {
    confirmBeforeProceeding(() => {
      setSelectedDepartment({} as SelectedDepartment);
    });
  }, [confirmBeforeProceeding, setSelectedDepartment]);

  return (
    <nav className="flex items-center justify-between min-h-[56px]">
      <div className="w-[50%]">
        <p className="font-bold text-left">{t('Manage Department GL Codes/Members')}</p>
      </div>

      <div className="flex justify-start w-[50%] ">
        <Button color="info" onClick={handleCancelClick} disabled={isSaveDepartmentLoading}>
          {isManageDepartmentDirty ? t('Cancel') : t('Back')}
        </Button>
        <Button
          onClick={handleSaveClick}
          disabled={!isManageDepartmentDirty || isSaveDepartmentLoading}
          color="primary"
          loading={isSaveDepartmentLoading}
        >
          {t('Save')}
        </Button>
      </div>
      <div className="ml-auto flex-row flex items-center justify-end">
        {company?.companyId ? guideMe : ''}
      </div>
    </nav>
  );
};

export default ManageDepartmentNavBar;
